/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'semantic-ui-react';
import { saveDisplayAC } from '../../action-creators';
import { setInitialValues } from './utils/form-utils';
import { Field, Formik } from 'formik';
import { BoothsField, ControlBoxField, InputField, QueuesField } from './fields';
import { ActionsSection } from './buttons/actions-section';
import { DropdownField } from './fields/dropdown-field';

const FIELDS = [
  'controlBoxId',
  'boothIds',
  'queueIds',
  'name',
  'displayType',
  'uuid',
  'secret',
  'layoutName',
  'themeName',
  'logoUrl'
];

function DisplayForm(props: any) {
  const { dispatch, onClose } = props;
  const boundHandleSubmit = (values: any, formikActions: any) =>
    dispatch(saveDisplayAC({ data: values, formikActions, closeDialog: onClose }));
  return (
    <Formik initialValues={setInitialValues(FIELDS, props)} onSubmit={boundHandleSubmit}>
      {({ values, handleSubmit, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Field name="name" label="Name" component={InputField} />
          <Field name="uuid" label="UUID" component={InputField} disabled={!!values.id} />
          <Field name="secret" label="Secret" component={InputField} />
          <Field name="controlBoxId" component={ControlBoxField} />
          <Field name="queueIds" component={QueuesField} />
          <Field name="boothIds" component={BoothsField} />
          <Field name="displayType">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Display type"
                options={[
                  { value: 'web', text: 'Web/HDMI Display (web)' },
                  { value: 'led', text: 'Led matrix display (led)' }
                ]}
              />
            )}
          </Field>

          <Field label="Layout Name" name="layoutName">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Layout Name"
                options={[
                  { value: 'default', text: 'Default' },
                  { value: 'dualLang', text: 'dualLang' },
                  { value: 'modern', text: 'modern' }
                ]}
              />
            )}
          </Field>
          <Field label="Theme Name" name="themeName">
            {(props: any) => (
              <DropdownField
                {...props}
                label="Theme Name"
                options={[
                  { value: 'default', text: 'Default' },
                  { value: 'blue', text: 'blue' },
                  { value: 'green', text: 'green' }
                ]}
              />
            )}
          </Field>

          <Field name="logoUrl" label="logoUrl" component={InputField} />
          <ActionsSection isNew={!values.id} disabled={isSubmitting} onCancel={props.onClose} />
        </Form>
      )}
    </Formik>
  );
}

const ConnectedComponent = connect((state: any) => ({
  app: state.app,
  serviceProviders: state.serviceProviders,
  queues: state.queues,
  booths: state.booths,
  controlBoxes: state.controlBoxes
}))(DisplayForm);

export default ConnectedComponent;
